<script setup>
import { useSlots } from "vue";
import { FormErrors, FormHelp, FormHint, FormLabel } from ".";

defineProps({
    label: {
        type: String,
        default: undefined,
    },
    hint: {
        type: String,
    },
    help: {
        type: String,
    },
    z: {
        type: Number,
        default: 0,
    },
    errors: {
        type: Array,
        default: [],
    },
});

const slots = useSlots();
</script>

<template>
    <div class="flex flex-col">
        <div :class="[label ? 'justify-between' : 'justify-end', 'flex items-center space-x-3']">
            <FormLabel v-if="label">
                {{ label }}
            </FormLabel>
            <slot name="hint">
                <FormHint v-if="hint" :z="z">
                    {{ hint }}
                </FormHint>
            </slot>
        </div>

        <div :class="[label || hint || !!slots.hint ? 'mt-2' : '']">
            <slot></slot>
        </div>

        <slot name="help">
            <FormHelp v-if="help" class="mt-2">
                {{ help }}
            </FormHelp>
        </slot>

        <FormErrors v-if="errors" class="mt-2" :errors="errors" />
    </div>
</template>
